var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"channels"},[_c('ul',{staticClass:"list-unstyled"},_vm._l((_vm.channels),function(channel,index){return _c('li',{key:index,staticClass:"channel"},[_c('img',{staticClass:"channel__logo",attrs:{"src":channel.web_logo,"alt":""}}),_c('span',{staticClass:"channel__title"},[_vm._v(_vm._s(channel.seo_title))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }